import { useCallback } from 'react';
import { useResource } from 'hooks/useResource';
import healthScoresService from 'services/healthScoresService';

// Latest stored health score for an Account, or null when none has been
// calculated yet. Shared by the LP360 KPI (CR-6567) and the Relationship
// Health Score component (CR-6569).
const useAccountHealthScores = (accountId) => {
	const fetchFn = useCallback(async () => {
		if (!accountId) return null;
		const scores = await healthScoresService.getHealthScores({
			salesforceObjectId: accountId,
		});
		// Endpoint returns an array ordered most-recent first; take the latest
		return scores?.[0] ?? null;
	}, [accountId]);

	const { data, loading, error } = useResource({ fetchFn });

	return {
		healthScores: data,
		loading,
		error,
	};
};

export default useAccountHealthScores;
